module.exports = __webpack_public_path__ + "media/newstyle/images/avaliacao2-992b5d5be5f6da6ec2df4d5d81184558.png";